export enum TruncateType {
	End,
	Middle,
	Start,
}

export interface ShortTextParams {
	maxLength?: number
	truncateType?: TruncateType
}
